import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { fetchTimeout } from "../components/Common";
import { Palette, API_BASE } from "../AppConfig";
import RecallQuotesLayout from "./RecallQuotesLayout";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
import Backdrop from "@material-ui/core/Backdrop";
import Typography from "@material-ui/core/Typography";
import Message from "../components/Message";
import AppsIcon from "@material-ui/icons/Apps";
import ListIcon from "@material-ui/icons/List";

import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";

import { updateAPP } from "../redux_store/appState";
import BSL_Dialog from "../components/BSL_Dialog";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";

const useStyles = makeStyles((theme) => ({
    page: {
        marginLeft: "120px",
        marginRight: "40px",
        marginTop: "20px",
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
        minHeight: "600px",
    },
    header: {
        fontWeight: "400",
        letterSpacing: "1px",
        paddingRight: "20px",
        verticalAlign: "text-top",
        color: theme.brand.LYSAGHT ? theme.palette.primary.light : Palette.Control.DarkGrey,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.brand.LYSAGHT ? "24pt" : "18pt",
        textTransform: theme.brand.LYSAGHT ? "uppercase" : "capitalize",
        fontWeight: theme.brand.LYSAGHT ? "800" : "inherit",
        flex: 1,
    },
    SubHeader: {
        fontWeight: "500",
        letterSpacing: "0.5px",
        paddingRight: "20px",
        verticalAlign: "text-top",
        color: theme.brand.LYSAGHT ? theme.palette.primary.light : Palette.Control.DarkGrey,
        fontFamily: theme.typography.fontFamily,
        fontSize: "14pt",
        textTransform: theme.brand.LYSAGHT ? "uppercase" : "capitalize",
        flex: 1,
    },
    view_panel: {
        font: "12pt " + theme.typography.fontFamily,
        display: "flex",
        alignItems: "center",
    },
    search_container: {
        borderRadius: "50px",
        border: "1px solid #6B8799",
    },
    search_icon: {
        width: "0.75em",
        height: "0.75em",
        color: "grey",
        marginLeft: "7px",
        verticalAlign: "-webkit-baseline-middle",
    },
    input: {
        display: "none",
    },
    backdrop: {
        zIndex: 10,
        color: "#fff",
        flexDirection: "column",
    },
}));

// const StyledMenuItem = withStyles((theme) => ({
//     root: {
//         font: "12pt " + theme.typography.fontFamily,
//     },
// }))(MenuItem);

// const StyledSelect = withStyles((theme) => ({
//     root: {
//         font: "12pt " + theme.typography.fontFamily,
//         marginLeft: "6px",
//         color: "#002D62",
//         // textDecoration: "underline"
//     },
// }))(Select);

export default function WorkAroundsPage(props) {
    const classes = useStyles();
    const [backDrop, setBackDrop] = React.useState(false);

    const main_page = useSelector((state) => state.app.MAIN_PAGE);

    useEffect(() => {}, [props.visible, main_page]);

    if (!props.visible) return null;

    return (
        <div className={classes.page}>
            <div style={{ display: "flex", flexDirection: "row" }}>
                <span className={classes.header}>LLD Work Around Documents</span>
                <div style={{ display: "flex", marginBottom: "4px" }}></div>
            </div>

            {backDrop && (
                <Backdrop className={classes.backdrop} open={backDrop}>
                    <>
                        <CircularProgress color="inherit" />
                        <br />
                        <Typography variant="overline" gutterBottom style={{ marginTop: "20px" }}>
                            {backDrop}
                        </Typography>
                    </>
                </Backdrop>
            )}

            <div style={{ marginTop: "20px" }}>
                <p>
                    <a
                        className={classes.SubHeader}
                        href="https://intercom.help/lysaghtliving/en/articles/8648879-lld-work-arounds"
                    >
                        LLD Work Arounds
                    </a>
                </p>
                <br></br>
                <p>
                    <a
                        className={classes.SubHeader}
                        href="https://intercom.help/lysaghtliving/en/articles/8400684-how-to-request-an-lld-license"
                    >
                        How To: Request an LLD License
                    </a>
                </p>
            </div>
        </div>
    );
}
